/* <ul class="rollable-list" data-rollable-list="container"> 
    <li class="rollable-list__item" data-rollable-list="item">
        <div class="rollable-list__header"> 
            <p class="rollable-list__header-text">Правда ли, что натуральный камень фонит?</p>
        </div>
        <div class="rollable-list__body">
            <div class="rollable-list__body-content" data-rollable-list="content">
                <p class="rollable-list__body-text">Многие противники натурального камня используют этот факт в качестве аргумента против использования камня. В США существует профессиональная ассоциация «Marble Institute of America». Они установили расчетным путем значение эмиссии радона (радиоактивный газ), составившее 0,00000074 пикокюри на куб. м. Для справки: когда вы открываете водопроводный кран, то радона в 10 в 7-й степени больше, чем в граните, а при включении телевизора получаете излучения в 109 больше.</p>
            </div>
        </div>
    </li>
</ul> */

class RollableList {
    constructor(element, options={}) {

        this.options = {
            activeClass: 'active'
        }
        this.options = {...this.options, ...options}
        this.items = {}
        this.activeIndex = null

        let itemElements = Array.from( element.querySelectorAll('[data-rollable-list="item"]') )
        this.items = itemElements.map( (itemElement, index) => {

            itemElement.setAttribute('data-index', index)
            const item = {
                element: itemElement,
                header: itemElement.children[0],
                body: itemElement.children[1],
                content: itemElement.children[1].querySelector('[data-rollable-list="content"]')
            }

            if ( this.activeIndex === null && itemElement.classList.contains(this.options.activeClass) ) {
                this.activeIndex = index
                this.setHeight( item )
            }

            return item
        })

        element.addEventListener('click', (e) => {
            let item = e.target.closest('[data-rollable-list="item"]')
            if (!item) return

            let header = item.children[0]
            if ( header.contains(e.target) ) {
                this.toggleItem( item )
            }
        })

        const resize_handler = ()=>this.setHeight( this.items[this.activeIndex] )
        window.addEventListener('resize', setEventDelay( event, resize_handler, 500, false))
    }

    toggleItem( itemElement ) {
        let index = +itemElement.dataset.index
        if ( index === undefined ) return

        if (this.activeIndex !== null && this.activeIndex !== index) {
            this.items[this.activeIndex].element.classList.remove( this.options.activeClass )
            this.items[this.activeIndex].body.style.height = ''
        }

        this.items[index].element.classList.add( this.options.activeClass )
        this.setHeight( this.items[index] )
        this.activeIndex = index
    }

    setHeight( item ) {
        if (!item) return

        if (item.content && item.content.offsetHeight) {
            item.height = item.content.offsetHeight + 'px'
            item.body.style.height = item.height
        }
    }
}

// functions
function setEventDelay(arg, f, ms, init = false, ...args) { // задержка для функции. init = true выполнить функцию до установки таймера.
    let timer = null

    function eventToArgs(e, args) {
        const argsLength = args.length
        if (argsLength <= args.length) {
            args[0] = e
        } else {
            args.unshift(e)
        }
    }

    function executor(e) {

        if (!timer) {
            if (init) {
                timer = setTimeout(() => {
                    clearTimeout(timer)
                    timer = null
                }, ms, e)
                eventToArgs(e, args)
                f(arg, ...args)
            } else {
                timer = setTimeout(
                    function () {
                        clearTimeout(timer)
                        timer = null
                        eventToArgs(e, args)
                        f(arg, ...args)
                    },
                    ms,
                    e
                )
            }
        }
    }

    return executor
}

export default RollableList